import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69263dde"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonPopup',
  props: {
    text: {},
    disable: { type: Boolean },
    refactor: { type: Boolean },
    onclick: { type: Function }
  },
  setup(__props: any) {

const { t } = useI18n();
const route = useRoute();
const idSmell = route.params.id;
const router = useRouter();



return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, { width: "500" }, _createSlots({
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps({ class: "exercise-button" }, props, {
        disabled: _ctx.disable,
        text: _ctx.text,
        onclick: _ctx.onclick
      }), null, 16, ["disabled", "text", "onclick"])
    ]),
    _: 2
  }, [
    (_ctx.refactor)
      ? {
          name: "default",
          fn: _withCtx(({}) => [
            _createVNode(_component_v_card, {
              class: "success",
              title: _unref(t)('buttonPopup.congratulations')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "text" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('buttonPopup.successTextOne')) + " ", 1),
                    _hoisted_1,
                    _createTextVNode(" " + _toDisplayString(_unref(t)('buttonPopup.successTextTwo')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      text: _unref(t)('buttonPopup.next'),
                      onClick: _cache[0] || (_cache[0] = () => _unref(router).push(`/chooseexercise/${_unref(idSmell)}`))
                    }, null, 8, ["text"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"])
          ]),
          key: "0"
        }
      : {
          name: "default",
          fn: _withCtx(({ isActive }) => [
            _createVNode(_component_v_card, {
              class: "fail",
              title: _unref(t)('buttonPopup.fail')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "text" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('buttonPopup.failTextOne')) + " ", 1),
                    _createElementVNode("br"),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('buttonPopup.failTextTwo')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      class: "green-button",
                      onClick: ($event: any) => (isActive.value = false)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttonPopup.close')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["title"])
          ]),
          key: "1"
        }
  ]), 1024))
}
}

})